import { useMe } from '../../auth/hooks/useMe';
import { UK_VAT } from '../constants';

const gatewayUseMeOptions = {
	enabled: true
};

export const useUkAwareText = (isGatewayPage?: boolean) => {
	const { me } = useMe(isGatewayPage ? gatewayUseMeOptions : undefined);
	const isUkUser = me?.vatCountry === UK_VAT;

	const selectUkAwareText = (globalTranslation: string, ukVariant: string) =>
		isUkUser ? ukVariant : globalTranslation;

	return {
		isUkUser,
		selectUkAwareText
	};
};
